import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { FlowIAFloatingAssistant } from './FlowIAFloatingAssistant';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

const COLLAPSE_KEY = 'spectra-rrhh-sidebar-collapsed';

export function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, sidebarCollapsed ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [sidebarCollapsed]);

  function toggleCollapse() {
    setSidebarCollapsed((c) => !c);
  }

  return (
    <div
      className={`app-shell${sidebarCollapsed ? ' app-shell--sidebar-collapsed' : ''}`}
      data-sidebar-collapsed={sidebarCollapsed ? 'true' : 'false'}
    >
      {mobileOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close menu"
          onClick={() => setMobileOpen(false)}
        />
      )}
      <Sidebar
        mobileOpen={mobileOpen}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleCollapse}
        onNavigate={() => setMobileOpen(false)}
      />
      <div className="app-main">
        <Header onMenuClick={() => setMobileOpen((o) => !o)} />
        <main className="app-content">
          <Outlet />
        </main>
      </div>
      <FlowIAFloatingAssistant />
    </div>
  );
}
